import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';
import LoadingSpinner from './Common/LoadingSpinner';
import NoPermissionAlert from './Common/NoPermissionAlert';
import { getRoleName } from '../utils/roleUtils';

const ProtectedRoute = ({ children, minLevel = 1, adminOnly = false }) => {
    const { user, loading } = useContext(AuthContext);
    const location = useLocation();

    if (loading) {
        return <LoadingSpinner />;
    }

    if (!user) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (adminOnly && !user.isAdmin) {
        return <NoPermissionAlert
            requiredRole="관리자"
            currentRole={getRoleName(user.roleLevel)}
        />;
    }

    if (!adminOnly && user.roleLevel < minLevel) {
        return <NoPermissionAlert
            requiredRole={getRoleName(minLevel)}
            currentRole={getRoleName(user.roleLevel)}
        />;
    }

    return children;
};

export default ProtectedRoute;
